import { observer } from 'mobx-react-lite';

function Spinner({ className }: ISpinnerProps) {
    return (
        <img className={className} src="spinner.gif" />
    );
}

export default observer(Spinner);

interface ISpinnerProps {
    className?: string;
}